import { Component } from '@angular/core';
import { AssociationDemoflyway_schema_historyEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Flyway _schema _histories') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-associationdemoflyway_schema_history-form',
    templateUrl: './associationdemoflyway_schema_history.form.component.html'
})
export class AssociationDemoflyway_schema_historyFormComponent extends BaseFormComponent {
    public record!: AssociationDemoflyway_schema_historyEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

